import { tabsAdmin, tabsGroups } from 'common/constants/tabs';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { setGroupList, setGroupName } from 'v3/data/store/group/actions';
import { setAllGroups, setGroupAdminList } from 'v3/data/store/groupAdmin/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { AddGroupButton } from 'v3/pages/Groups/List/addGroupOrAdmin';
import { Container, Content, Header } from 'v3/pages/Stores/List/styles';
import * as api from 'v3/services/api';
import { createGroup } from 'v3/services/api';
import { GroupAdminFilter } from 'v3/shared/components/Filters/GroupAdminFilter';
import { GenericNameModal } from 'v3/shared/components/Modal/GenericNameModal';
import { GroupAdminModal } from 'v3/shared/components/Modal/GroupAdminModal';
import { IModal, Mode } from 'v3/shared/components/Modal/GroupAdminModal/types';
import { GroupsAdminTable } from 'v3/shared/components/Table/GroupAdminTable';
import { GroupsTable } from 'v3/shared/components/Table/GroupTable';
import { GroupsFilter } from 'v3/shared/components/Table/GroupTable/GroupFilter';
import LabTabs from 'v3/shared/components/Tabs';
import { TabsEnum } from 'v3/shared/enums/tabs-emun';
import { CommonTemplate } from 'v3/shared/templates/CommonTemplate';
import { HeadlineMedium } from 'v3/shared/typography/HeadlineMedium';
export const GroupsList = () => {
  const { group } = useStoreSelector((store) => store.store.storeLogged);
  const { filter: groupsFilter } = useStoreSelector((store) => store.group);
  const { filter: groupAdminFilter, list: groupAdminList, allGroups } = useStoreSelector((store) => store.groupAdmin);
  const { list: groupList } = useStoreSelector((store) => store.group);

  const isAdmin = group === StoreProfileEnum.MASTER_ADMIN;
  const [tabValue, setTabValue] = useState<TabsEnum>(TabsEnum.AdminTab);
  const availableTabs = isAdmin ? tabsAdmin : tabsGroups;
  const { isDesktop } = useBreakpoints();

  const [openGroupModal, setOpenGroupModal] = useState(false);
  const [groupAdminModal, setGroupAdminModal] = useState<IModal>({
    active: false,
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    title: '',
    mode: Mode.Create,
  });

  const getGroupList = useCallback(async () => {
    try {
      const response = await api.getGroupList(groupsFilter);
      setGroupList(response.data);
    } catch (error) {
      showErrorDialog('Erro ao obter lista de Grupos', error);
    }
  }, [groupsFilter]);

  const getGroupAdminList = useCallback(async () => {
    try {
      const response = await api.getGroupAdminList(groupAdminFilter);
      setGroupAdminList(response.data);
    } catch (error) {
      showErrorDialog('Erro ao obter lista de grupo admins', error);
    }
  }, [groupAdminFilter]);

  const handleCreateGroup = async (name: string) => {
    const normalizedName = name.trim().toLowerCase();

    const isDuplicate = groupList.items?.some((group) => group.name.trim().toLowerCase() === normalizedName);

    if (isDuplicate) {
      showSnackbar('Já existe um grupo com este nome', 'error', true);
      return;
    }

    try {
      const response = await createGroup({ name });
      setGroupName(response.data);
      showSnackbar('Grupo criado com sucesso', 'success', true);
      setOpenGroupModal(false);
      getGroupList();
      getAllGroups();
    } catch (error) {
      showSnackbar('Erro ao criar novo grupo', 'error', true);
      console.error(error);
    }
  };

  const handleOpenGroupAdminModal = (mode: Mode) => {
    if (mode === Mode.Create) {
      setGroupAdminModal({ ...groupAdminModal, active: true, title: 'Cadastrar grupo admin' });
      return;
    }
    setGroupAdminModal({ ...groupAdminModal, active: true, title: 'Editar grupo admin', mode: Mode.Edit });
  };

  const getAllGroups = useCallback(async () => {
    try {
      const response = await api.getAllStoreGroups();
      setAllGroups(response.data);
    } catch (error) {
      showErrorDialog('Erro ao buscar todos os grupos', error);
      console.error(error);
    }
  }, []);

  useEffect(() => {
    getAllGroups();
  }, []);

  useEffect(() => {
    getGroupList();
  }, [groupsFilter]);

  useEffect(() => {
    getGroupAdminList();
  }, [groupAdminFilter]);

  return (
    <CommonTemplate>
      <Container>
        <Content>
          <Header>
            <HeadlineMedium>Lista de grupos</HeadlineMedium>
            <AddGroupButton
              tabValue={tabValue}
              isDesktop={isDesktop}
              onClickGroup={() => setOpenGroupModal(true)}
              onClickAdmin={() => handleOpenGroupAdminModal(Mode.Create)}
            />
          </Header>

          <LabTabs tabsData={availableTabs} tabValue={tabValue} setTabValue={setTabValue} />
          {tabValue === TabsEnum.GroupTab && (
            <Fragment>
              <GroupsFilter />
              <GroupsTable groupList={groupList} />
            </Fragment>
          )}

          {tabValue === TabsEnum.AdminTab && (
            <Fragment>
              <GroupAdminFilter />
              <GroupsAdminTable groupsAdminList={groupAdminList} />
            </Fragment>
          )}
        </Content>
      </Container>
      <GroupAdminModal
        modal={groupAdminModal}
        fullStoreGrouplist={allGroups}
        onClose={() => setGroupAdminModal({ ...groupAdminModal, active: false })}
        onConfirm={(data, reset) => setGroupAdminModal({ ...groupAdminModal, active: false })}
      ></GroupAdminModal>

      <GenericNameModal
        title="Cadastrar grupo"
        active={openGroupModal}
        onClose={() => setOpenGroupModal(false)}
        onSave={handleCreateGroup}
      />
    </CommonTemplate>
  );
};
